module.exports = __webpack_public_path__ + "components/flag/static/square/dj-eedf1ab67c96989a7651f2ef261269f8.svg";